module.exports = __webpack_public_path__ + "img/4_35.de80a2b6.png";